import React from "react";

const NotFound = () => {
    return (
        <div>
            <h1 style={{color : "white"}}>404 Not Found</h1>
            <p style={{color : "white"}}>페이지를 찾을 수 없습니다.</p>
        </div>
    )
};

export default NotFound;